import { MATRIX_ARCANA } from '@/api/consts'
import type { MatrixPoint, MatrixSection } from '@/api/groups-matrix'
import type { MatrixOfDestiny } from '@/api/services/numer'

export function formatMatrixArcana(matrix: MatrixOfDestiny | null, point: MatrixPoint) {
  if (!matrix) return ''

  const arcana = matrix[point]
  const arcanaName = MATRIX_ARCANA[arcana]?.name

  return arcanaName ? `${arcanaName} (${arcana})` : arcana.toString()
}

export function getMatrixSectionQuestion(
  section: MatrixSection,
  matrix: MatrixOfDestiny | null,
) {
  return section.question.replace(/\{points\[(\d+)\]\}/g, (match, idx) => {
    const point = section.points[Number(idx)]

    return point ? formatMatrixArcana(matrix, point) : match
  })
}
